import { render, staticRenderFns } from "./CopyToInvite.vue?vue&type=template&id=f2022510&scoped=true"
import script from "./CopyToInvite.vue?vue&type=script&lang=js"
export * from "./CopyToInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2022510",
  null
  
)

export default component.exports